/**
 * DIFF-5 seed — daily_ops_briefs. One pre-generated brief per role so the
 * UI shows role-differentiation immediately on first load even before the
 * 6am CF run lands.
 */
import { DEMO_TENANT_ID } from './tenantDefaults';

const T = DEMO_TENANT_ID;
const nowIso = () => new Date().toISOString();
const today = () => new Date().toISOString().slice(0, 10);

export const SEED_DAILY_OPS_BRIEFS = [
  {
    id: `${T}__dispatcher__${today()}`, tenantId: T, role: 'dispatcher', dateKey: today(),
    generatedAt: nowIso(),
    sections: [
      {
        key: 'priority_loads', title: '6 priority loads today', tone: 'accent',
        items: [
          { label: 'WC-10780 — Pacific Fresh Foods', detail: 'Dallas → Denver · in_transit',  actionUrl: '/tms/loadboard', actionLabel: 'Track' },
          { label: 'WC-10781 — Heartland Grain Co',  detail: 'Wichita → Oklahoma City · tendered', actionUrl: '/tms/loadboard', actionLabel: 'Track' },
          { label: 'WC-10782 — Sunrise Beverages',   detail: 'Modesto → Reno · tendered',    actionUrl: '/tms/loadboard', actionLabel: 'Track' },
          { label: 'WC-10760 — Midwest LTL auto',    detail: 'Chicago → Indianapolis · tendered', actionUrl: '/tms/loadboard', actionLabel: 'Track' },
          { label: 'WC-10762 — Long-Haul recommend', detail: 'Dallas → Los Angeles · tendered',   actionUrl: '/tms/loadboard', actionLabel: 'Track' },
          { label: 'WC-10775 — Keyston ETA confirmed', detail: 'Toledo → Buffalo · in_transit', actionUrl: '/tms/loadboard', actionLabel: 'Track' },
        ],
      },
      {
        key: 'exceptions', title: '2 open exception(s) · 1 predicted', tone: 'danger',
        items: [
          { label: 'Delay: Mechanical Breakdown',     detail: 'critical · WC-10712',        actionUrl: '/tms/status-engine', actionLabel: 'Handle' },
          { label: 'Detention at shipper facility',   detail: 'high · WC-10721',           actionUrl: '/tms/status-engine', actionLabel: 'Handle' },
          { label: 'WC-10780 · 82% risk in 4h',       detail: 'low_trust_carrier · hos_expiring', actionUrl: '/tms/status-engine', actionLabel: 'Engage AEGIS' },
        ],
      },
      {
        key: 'consolidation', title: '3 consolidation opportunities', tone: 'success',
        items: [
          { label: 'IL::TX — $742 savings',  detail: 'Cross-customer pair · 41,200 lbs combined',  actionUrl: '/tms/consolidation-engine', actionLabel: 'Accept' },
          { label: 'CA::NV — $528 savings',  detail: '2 LTL fit into FTL on CA::NV',               actionUrl: '/tms/consolidation-engine', actionLabel: 'Accept' },
          { label: 'GA → AL — $386 savings', detail: 'Asset returning from GA',                    actionUrl: '/tms/consolidation-engine', actionLabel: 'Accept' },
        ],
      },
    ],
    isDeleted: false, createdAt: nowIso(), updatedAt: nowIso(), version: 1, source: 'daily_ops_intel',
  },
  {
    id: `${T}__account_manager__${today()}`, tenantId: T, role: 'account_manager', dateKey: today(),
    generatedAt: nowIso(),
    sections: [
      {
        key: 'revenue_at_risk', title: '$18,400 revenue at risk today', tone: 'danger',
        items: [
          { label: 'Pacific Fresh Foods · $8,400 · 82% delay risk', detail: 'Load WC-10780', actionUrl: '/tms/status-engine', actionLabel: 'Engage AEGIS' },
          { label: 'Heartland Grain Co · $6,200 · 58% delay risk',  detail: 'Load WC-10781', actionUrl: '/tms/status-engine', actionLabel: 'Engage AEGIS' },
          { label: 'Sunrise Beverages · $3,800 · 42% delay risk',   detail: 'Load WC-10782', actionUrl: '/tms/status-engine', actionLabel: 'Engage AEGIS' },
        ],
      },
      {
        key: 'customer_exposure', title: '3 customer(s) exposed to low-trust carriers', tone: 'warning',
        items: [
          { label: 'Pacific Fresh Foods', detail: '2 load(s) · $12,400 exposure',  actionUrl: '/tms/carrier-vetting', actionLabel: 'Review' },
          { label: 'Keyston Bros',        detail: '1 load(s) · $4,200 exposure',   actionUrl: '/tms/carrier-vetting', actionLabel: 'Review' },
          { label: 'Riverside NF',        detail: '1 load(s) · $2,800 exposure',   actionUrl: '/tms/carrier-vetting', actionLabel: 'Review' },
        ],
      },
    ],
    isDeleted: false, createdAt: nowIso(), updatedAt: nowIso(), version: 1, source: 'daily_ops_intel',
  },
  {
    id: `${T}__executive__${today()}`, tenantId: T, role: 'executive', dateKey: today(),
    generatedAt: nowIso(),
    sections: [
      {
        key: 'financials_topline', title: 'Today’s financials', tone: 'accent',
        items: [
          { label: 'Revenue booked',         detail: '$247,860',                actionUrl: '/overview/exec-command', actionLabel: 'Open' },
          { label: 'Revenue in transit',     detail: '$142,400',                actionUrl: '/overview/exec-command', actionLabel: 'Open' },
          { label: 'Margin',                 detail: '$41,180 (16.6%)',          actionUrl: '/overview/exec-command', actionLabel: 'Open' },
          { label: 'Exception cost',         detail: '$4,260',                   actionUrl: '/tms/status-engine',     actionLabel: 'Review' },
          { label: 'Consolidation savings',  detail: '$2,185',                   actionUrl: '/tms/consolidation-engine', actionLabel: 'Review' },
        ],
      },
      {
        key: 'exec_actions', title: 'Recommended for your attention', tone: 'accent',
        items: [
          { label: 'Generate monthly board doc', detail: 'One-click PDF export with AEGIS summary', actionUrl: '/overview/exec-command', actionLabel: 'Generate' },
          { label: 'Review at-risk accounts',     detail: 'AM brief flags $18.4K revenue exposure',  actionUrl: '/overview/daily-ops?role=account_manager', actionLabel: 'Switch view' },
        ],
      },
    ],
    isDeleted: false, createdAt: nowIso(), updatedAt: nowIso(), version: 1, source: 'daily_ops_intel',
  },
  {
    id: `${T}__sales__${today()}`, tenantId: T, role: 'sales', dateKey: today(),
    generatedAt: nowIso(),
    sections: [
      {
        key: 'cross_sell', title: '1 multi-customer consolidation lead', tone: 'success',
        items: [
          { label: 'IL::TX — $742 savings', detail: 'Customers: Pacific Fresh, Heartland Grain', actionUrl: '/tms/consolidation-engine', actionLabel: 'View' },
        ],
      },
      {
        key: 'active_accounts', title: '8 active account(s)', tone: 'accent',
        items: [
          { label: 'Pacific Fresh Foods',   detail: 'enterprise',     actionUrl: '/tms/customers/cust-pacific-fresh',    actionLabel: 'Open' },
          { label: 'Heartland Grain Co',    detail: 'mid-market',     actionUrl: '/tms/customers/cust-heartland-grain',  actionLabel: 'Open' },
          { label: 'Sunrise Beverages',     detail: 'mid-market',     actionUrl: '/tms/customers/cust-sunrise-beverages', actionLabel: 'Open' },
          { label: 'Keyston Bros',          detail: 'enterprise',     actionUrl: '/tms/customers/cust-keyston',          actionLabel: 'Open' },
          { label: 'Riverside NF',          detail: 'strategic',      actionUrl: '/tms/customers/cust-riverside',        actionLabel: 'Open' },
        ],
      },
    ],
    isDeleted: false, createdAt: nowIso(), updatedAt: nowIso(), version: 1, source: 'daily_ops_intel',
  },
];

export const DAILY_OPS_SEED_SUMMARY = {
  daily_ops_briefs: SEED_DAILY_OPS_BRIEFS.length,
};
